import {partyId} from "./party";
import {generateUUID} from "./helpers/uuid";

type InitResponse = {
    partyId: string;
}

export const init = () => {
    const id = generateUUID();
    const origin = window.location.origin;
    // TODO: use env var for the target origin
    window.parent.postMessage({
        id,
        key: 'giga.init',
        origin,
        partyId
    }, '*')

    let resolvePromise;
    const handleMessage = (event) => {

        if (event.data.id !== id) return;

        if (event.data.key === 'giga.init') {
            resolvePromise({
                partyID: partyId
            })

            // remove the event listener once parent has responded
            window.removeEventListener('message', handleMessage);
        }
    };

    return new Promise<InitResponse>((resolve) => {
        resolvePromise = resolve;
        window.addEventListener('message', handleMessage);
    });
};

